/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Form } from 'react-bootstrap';

interface Option {
  label: string;
  value: string | number;
}

interface SelectFormProps {
  options: Option[];
  value: string | number;
  onChange: (
    value: string | number,
    selectedOption: Option | undefined
  ) => void;
  label: string;
  className?: string;
  selectRef?: React.Ref<HTMLSelectElement>;
}

const SelectForm = ({
  options,
  value,
  onChange,
  label,
  className = '',
  selectRef
}: SelectFormProps) => {
  return (
    <Form.Floating className={`position-relative ${className}`}>
      <Form.Select
        ref={selectRef}
        value={value}
        onChange={e => {
          const selectedVal = e.target.value;
          const selectedOption = options?.find(
            opt => String(opt.value) === selectedVal
          );
          onChange(selectedVal, selectedOption);
        }}
      >
        {options?.map(option => (
          <option key={option?.value} value={option?.value}>
            {option?.label}
          </option>
        ))}
      </Form.Select>
      <label>{label}</label>
    </Form.Floating>
  );
};

export default SelectForm;
